import NavbarLink from "./NavbarLink";
import { handleOpenChat } from "utils/analytics";

export default function Navbar(props: any) {
    return (
      <nav className={`hidden lg:flex ${ props.show ? "mobile" : "" }`}>
        <NavbarLink to="/piscinas-naturais" title="Piscinas Naturais" />
        <NavbarLink to="/passeio-de-orla" title="Passeio de Orla" />
        <NavbarLink to="/buggy-maragogi-norte" title="Buggy Maragogi Norte" />
        <NavbarLink to="/buggy-maragogi-sul" title="Buggy Maragogi Sul" />
        <NavbarLink to="/buggy-sao-miguel" title="Buggy São Miguel" />
        <div className="flex lg:hidden" title="" > 
          <div className="py-2 w-36 px-4 text-white bg-orange-400 rounded text-center">
            <button type="button" onClick={handleOpenChat}>
              Fale conosco
            </button>
          </div>
        </div>
      </nav>
    )
}